import React, { useState, useEffect, useContext } from "react";
import FiberCoresTable from "./FiberCoresTable";
import Axios from "axios"; // Import Axios for API requests
import Modal from "react-bootstrap/Modal"; // Import Bootstrap Modal
import Alert from "react-bootstrap/Alert"; // Import Alert for messages
import AuthContext from "../context/AuthContext"; // Import AuthContext for user authentication
import { API_URL } from "../components/api"; // Import API URL
import LanguageContext from "../context/LanguageContext";
import Select from "react-select"; // Import Select for dropdowns

function FiberCores() {
  const [data, setData] = useState([]);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false); // Close modal
  const handleShow = () => setShow(true); // Show modal
  let { user } = useContext(AuthContext);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const authTokens = JSON.parse(localStorage.getItem("authTokens"));
        const response = await Axios.get(`${API_URL}/radius/fiber/cores/access/`, {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
          params: {
            username: user.username,
          },
        });

        if (response.status === 200) {
          setData(response.data.authorized === true);
          console.log(response.data);
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);
  return (
    <div className="Buildings">
      {/* Button to trigger the Add ONU modal */}
      {data === true && (
        <button
          onClick={handleShow}
          className="edit-client"
          style={{ marginTop: "10px", marginLeft: "10px" }}
        >
          Add Fiber Core
        </button>
      )}
      {/* Main content displaying the ONUTables */}
      <div className="main">
        <FiberCoresTable />
      </div>

      {/* Modal for adding a new ONU */}
      <Modal show={show} onHide={handleClose} className="modal-lg">
        <Modal.Header closeButton>
          <Modal.Title>Add FiberCores</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FiberForm parentFunction={handleClose} />
        </Modal.Body>
      </Modal>
    </div>
  );
}

function FiberForm(props) {
  const [message, setMessage] = useState(null);

  let { user } = useContext(AuthContext);
  let authTokens = JSON.parse(localStorage.getItem("authTokens"));
  const [code, setcode] = useState("");
  const [status, setstatus] = useState("");
  const [mgrs, setmgrs] = useState("");
  const [type, settype] = useState("");
  const [sticker, setsticker] = useState("");
  const [map, setmap] = useState("");
  const [fiber_meters, setfiber_meters] = useState("");
  const [parent_core, setparent_core] = useState("");
  const [parentCores, setparentCores] = useState([]);
  const [zone_name, setzone_name] = useState("");
  const [zones, setzones] = useState([]);
  const { language, t } = useContext(LanguageContext);

  const showMessage = (message, type = "success") => {
    setMessage({ text: message, type });

    // Close the modal after 3 seconds
    if (type === "success") {
      setTimeout(() => {
        props.parentFunction(); // Correctly call the passed parent function
      }, 1200);
    }

    // Clear the message after 5 seconds
    setTimeout(() => {
      setMessage(null);
    }, 5000);
  };

  const types = [
    { value: "P2C", label: "P2C" },
    { value: "C2C", label: "C2C" },
    { value: "B2C", label: "B2C" },
    { value: "C2B", label: "C2B" },
  ];
  const state = [
    { value: "Ready", label: "Ready" },
    { value: "Pending", label: "Pending" },
    { value: "Active", label: "Active" },
    { value: "Disabled", label: "Disabled" },
  ];
  const stickers = [
    { value: "Private", label: "Private" },
    { value: "NO", label: "NO" },
    { value: "Yes", label: "Yes" },
  ];
  const options = [
    { value: "YES", label: "YES" },
    { value: "NO", label: "NO" },
  ];

  // Fetch buildings from the backend
  useEffect(() => {
    Axios.get(`${API_URL}/radius/fiber/cores/`, {
      headers: {
        Authorization: `Bearer ${authTokens.access}`,
      },
      params: {
        username: user.username,
      },
    })
      .then((response) => {
        const cores = response.data.map((core) => ({
          value: core.code,
          label: core.code,
        }));
        setparentCores(cores);
      })
      .catch((error) => {
        console.error("Error fetching parent cores:", error);
      });
  }, []);

  useEffect(() => {
    Axios.get(`${API_URL}/radius/fiber/zone/`, {
      headers: {
        Authorization: `Bearer ${authTokens.access}`,
      },
      params: {
        username: user.username,
      },
    })
      .then((response) => {
        setzones(
          response.data.map((z) => ({ value: z.zone_name, label: z.zone_name }))
        );
      })
      .catch((error) => {
        console.error("Error fetching zones:", error);
      });
  }, []);

  let handleSubmit = async (e) => {
    e.preventDefault();
    Axios.post(
      `${API_URL}/radius/fiber/cores/`,
      {
        Action: "Post",
        code: code,
        sticker: sticker,
        status: status,
        mgrs: mgrs,
        type: type,
        map: map,
        fiber_meters: fiber_meters,
        parent_core: parent_core,
        zone_name: zone_name,
        userdealer: user.username,
      },
      {
        headers: {
          Authorization: `Bearer ${authTokens.access}`,
        },
      }
    )
      .then((response) => {
        console.log(response);
        showMessage("Add successful!", "success"); // Show the success message
      })
      .catch((error) => {
        console.log(error);
        const addCode = error?.response?.data?.code;
        showMessage(
          language === "ar"
            ? t(
                addCode === "code_required"
                  ? "fiberCores.codeRequired"
                  : addCode === "code_exists"
                    ? "fiberCores.codeExists"
                    : addCode === "zone_not_found"
                      ? "fiberCores.zoneNotFound"
                      : "fiberCores.addFailed"
              )
            : error?.response?.data?.message || "Add failed!",
          "danger"
        ); // Show the error message
      });
  };

  return (
    <div className="testi">
      <div className="mod">
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>
              Code:
              <input
                className="form-control"
                type="text"
                value={code}
                onChange={(e) => setcode(e.target.value)}
                placeholder="Enter code"
              />
            </label>
            <label>
              Status:
              <Select
                className="search-line"
                options={state}
                onChange={(opt) => setstatus(opt.value)}
                placeholder="Enter status"
              />
            </label>
            <label>
              Type:
              <Select
                className="search-line"
                options={types}
                onChange={(opt) => settype(opt.value)}
                placeholder="Enter type"
              />
            </label>
          </div>
          <div className="form-group">
            <label>
              Sticker:
              <Select
                className="search-line"
                options={stickers}
                onChange={(opt) => setsticker(opt.value)}
                placeholder="Enter sticker"
              />
            </label>
          </div>
          <div className="form-group">
            <label>
              MAP:
              <Select
                className="search-line"
                options={options}
                onChange={(opt) => setmap(opt.value)}
                placeholder="Enter map"
              />
            </label>
          </div>
          <label>
            Location:
            <input
              className="form-control"
              type="text"
              value={mgrs}
              onChange={(e) => setmgrs(e.target.value)}
              placeholder="Enter location"
            />
          </label>
          <label>
            Fiber Meters:
            <input
              className="form-control"
              type="number"
              value={fiber_meters}
              onChange={(e) => setfiber_meters(e.target.value)}
              placeholder="Enter fiber meters"
            />
          </label>
          <label>
            Parent Core:
            <Select
              className="search-line"
              options={parentCores}
              onChange={(opt) => setparent_core(opt.value)}
              placeholder="Enter Parent Core"
            />
          </label>
          <label>
            {language === "ar" ? t("fiberCores.zone") : "Zone:"}
            <Select
              className="search-line"
              options={zones}
              isClearable
              onChange={(opt) => setzone_name(opt ? opt.value : "")}
              placeholder={language === "ar" ? t("fiberCores.selectZone") : "Select zone"}
            />
          </label>
          <div className="fo">
            <button type="submit" className="btn btn-primary btn-md">
              Add
            </button>
          </div>
        </form>
      </div>
      {/* Popup Message */}
      {message && (
        <div
          className={`alert alert-${message.type} alert-dismissible fade show`}
          role="alert"
          style={{
            position: "fixed",
            bottom: "10px",
            margin: "10px",
            right: "10px",
            zIndex: "9999",
          }}
        >
          {message.text}
        </div>
      )}
    </div>
  );
}

export default FiberCores;
